import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import attendce from '@/views/ViewsComponents/attendance/Attendance.vue'
import attendceDeatils from '@/views/ViewsComponents/attendance/AttendanceDetails.vue'
import overtime2Salary from '@/views/ViewsComponents/attendance/Overtime2Salary.vue'
import leaves from '@/views/ViewsComponents/attendance/Leaves.vue'
import holiday from '@/views/ViewsComponents/attendance/Holiday.vue'
import holidayCount from '@/views/ViewsComponents/attendance/HolidayCount.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "考勤" }, {
          default: _withCtx(() => [
            _createVNode(attendce)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "考勤详情",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(attendceDeatils)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "请假",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(leaves)
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_tab_pane, {
          label: "节假日",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(holiday)
          ]),
          _: 1
        })), [
          [_directive_permission, void 0, "checkin"]
        ]),
        _createVNode(_component_el_tab_pane, {
          label: "假期余额",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(holidayCount)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})